module.exports = __webpack_public_path__ + "static/media/brawl_stars_leon.07c474ba.png";